// [start, end] dates -> [startOfDay, endOfDay] ISO strings (local time). Empty / no start -> [] (no filter)
export const toDayRangeISO = (range) => {
  const [from, to] = range || [];
  if (!from) return [];
  const start = new Date(from);
  start.setHours(0, 0, 0, 0);
  const end = new Date(to || from);
  end.setHours(23, 59, 59, 999);
  return [start.toISOString(), end.toISOString()];
};
